import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { storeDataTablePayload } from "../../../Redux/Actions/dataTableActions";
import store from "../../../Store/store";
import { DataTableType } from "../../../Types/editableFamilyGroupType";
import { IColumn } from "../../../Types/gridDataProps";
import { endpoints } from "../../../ApiEndPoints/apiEndPoints";
import { InformationPopup } from "../../SharedComponents/InformationPopup";
import { createColumn, createColumnWithRender, createDateColumn } from "../../../helpers/tableHelper";
import { List, ListItem } from "@sainsburys-tech/luna-list";

const FoodVolumetrics: FC<DataTableType> = (props: DataTableType) => {
  const user = useSelector((state: any) => state.auth.user);

  const columnDefinition: IColumn[] = [
    createColumn("DCP", "DCP"),
    createColumn("Super Category Description", "SuperCatDesc"),
    createColumn("Department Code", "DeptCode"),
    createColumn("Commodity Code", "CommCode"),
    createColumn("Pack Size", "PackSize"),
    createColumn("Sku Number", "SkuNo"),
    createColumn("Supplier Code", "SuppCode"),
    createColumn("Supplier Name", "SuppName"),
    createColumn("Office Description", "OfficeDesc"),
    createColumn("Description", "Desc"),
    createColumn("Break Pack", "BreakPack"),
    createColumn("Case Length (Mm)", "CaseLengthMm"),
    createColumn("Case Width (Mm)", "CaseWidthMm"),
    createColumn("Case Height (Mm)", "CaseHeightMm"),
    createColumn("Case Weight (Kg)", "CaseWeightKg"),
    createColumn("Weight UOM", "WeightUom"),
    createColumn("Cases Per Layer", "CasesPerLayer"),
    createColumn("Layers Per Pallet", "LayersPerPallet"),
    createColumn("Cases Per Pallet", "CasesPerPallet"),
    createColumnWithRender("Rejection Reason", "RejectionReason", ({value}) => {
      return value
          ? (
            <div>
              <InformationPopup
                modalHeading={`Rejection Reason`}
                dataPage="ProductVolumetricsReview"
                initialValue={value.substring(0, 20)}>
                <List>
                  {value.split(".").map((rejectionMessage: string) => {
                    const trimmedRejectionMessage = rejectionMessage.trim();
                    return trimmedRejectionMessage ? (
                      <ListItem key={trimmedRejectionMessage}>{trimmedRejectionMessage}</ListItem>
                    ) : null;
                  })}
                </List>
              </InformationPopup>
            </div>)
          : (<>--</>);
    }),
    createColumn("File Name", "FileName"),
    createDateColumn("Upload Date", "UploadDate", { td: "no-wrap" })
  ];

  if (user?.isLDMService) {
    columnDefinition.push({
      name: "",
      accessor: "",
      type: "btn",
      btnType: "edit",
    });
  }

  useEffect(() => {
    let payload = {
      service: endpoints.getVolumetricsReviewData(),
      columnDefinition: columnDefinition,
      toggleSearchPanel: (e: any) => props.toggleSearchPanel(e),
      isColumnMerge: true,
    };
    store.dispatch(storeDataTablePayload(payload));
  }, []);

  return <></>;
};

export default FoodVolumetrics;